import { formatDuration } from 'date-fns';
import { enGB, pt } from 'date-fns/locale';

const STALE_SYNC_THRESHOLD_MS = 13 * 60 * 60 * 1000;

export const getSyncDelay = (
  lastSuccessfulSyncAt: Date | null | undefined,
  now: number,
) => {
  const timestamp = lastSuccessfulSyncAt?.getTime();
  if (timestamp === undefined || !Number.isFinite(timestamp)) {
    return null;
  }

  const elapsedMs = Math.max(0, now - timestamp);
  return { elapsedMs, isStale: elapsedMs > STALE_SYNC_THRESHOLD_MS };
};

export const formatSyncDelay = (elapsedMs: number, language: string) => {
  const totalMinutes = Math.floor(elapsedMs / 60000);
  return formatDuration(
    {
      days: Math.floor(totalMinutes / 1440),
      hours: Math.floor((totalMinutes % 1440) / 60),
      minutes: totalMinutes % 60,
    },
    { locale: language.startsWith('pt') ? pt : enGB },
  );
};
